import React from "react";
import PowerBy from "./components/power-by";

const Footer = () => <PowerBy />;

export default Footer;
